import {
    IAssignedJobListRecord,
    ICandidateJob,
    IClientJobStatistics,
    IJob,
    IJobAttribute,
    IJobBenefitsOption,
    ISaveJobRequirement,
    IJobRequirementOption,
    IJobsBoardFilter,
    IStepperInfo,
    jobsBoardFiltersInitState,
    jobStepperInfoInitState,
    IJobCandidatesByStep,
    IApplyQuestion,
    IServerJobRequirementRecommendation,
    IJobLabelOption,
    IJobStep,
} from '../../../common';

export interface IPublishedJob {
    id: number;
    title: string;
    applyQuestions: Array<IApplyQuestion>;
}
import {
    IFetchActiveJobAction,
    ISetActiveJobAction,
    IUpdateCandidateSavedJobsAction,
    IUpdateActiveJobAction,
    ISetJobsPageStatisticsAction,
    ISetJobAttributeListAction,
    ISaveJobAction,
    ISetStepperInfoAction,
    ISetJobRequirementsOptionsAction,
    ISetCandidatesJobsAction,
    IFetchCandidatesJobsAction,
    ISetJobsBoardFiltersAction,
    ISetJobBenefitsOptionsAction,
    IUpdateJobStatusAction,
    IDeleteJobAction,
    IFetchRequirementsOptionsAction,
    ISetAssignedJobListAction,
    ISetTrackableSourcesAction,
    ICreateTrackableSourceAction,
    ISetJobsListAction,
    ISetCancelOrCloseJobAction,
    IFetchJobRequirementsRecomendationsAction,
    ISetJobRequirementsRecomendationsAction,
    ISetFormattedJobRequirementsRecomendationsAction,
    ISetJobOverviewAndResponsibilitiesAction,
    IFetchJobOverviewAndResponsibilitiesAction,
    ISetActiveJobCandidatesAction,
    IFetchActiveJobCandidatesAction,
    ISetActiveCandidateJobIdAction,
    IUpdateActiveJobCandidateAction,
    IUpdateActiveJobCandidateNameAction,
    ISetCopiedJobStepsAction,
    IDeleteJobTagAction,
} from './interface';
import { ISetTagAction } from '../../jobApplication/redux/interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface IJobSlice {
    activeJob: IJob | null;
    activeJobCandidates: Array<IJobCandidatesByStep>;
    activeCandidateJobId: number | null;
    candidateSavedJobs: Array<string>;
    jobAttributeList: Array<IJobAttribute>;
    jobRequirementsOptions: Array<IJobRequirementOption>;
    jobBenefitsOptions: Array<IJobBenefitsOption>;
    jobsPageStatistics: IClientJobStatistics | null;
    jobStepperInfo: IStepperInfo;
    candidatesJobs: Array<ICandidateJob>;
    jobsBoardFilters: Array<IJobsBoardFilter>;
    publishedJobs: Array<IPublishedJob>;
    assignedJobList: Array<IAssignedJobListRecord>;
    jobRequirementsRecomendations: Array<IJobRequirementOption>;
    formattedJobRequirementsRecomendations: Array<ISaveJobRequirement>;
    jobOverviewAndResponsibilitiesRecommmendation: {
        overview: string | null;
        responsibilities: string | null;
    };
    trackableSources: Record<string, string>;
    publicTrackableSources: Record<string, string>;
    jobsList: Array<IJobLabelOption>;
    cancelOrCloseJob: ISetCancelOrCloseJobAction | null;
    activeJobRequirementRecommendations: Array<IServerJobRequirementRecommendation>;
    isRecommendationsExhausted: boolean;
    copiedJobSteps: Array<IJobStep> | null;
    uiState: {
        isJobLoading: boolean;
        isUpdateJobLoading: boolean;
        isJobsPageStatisticsLoading: boolean;
        isCandidatesJobsLoading: boolean;
        isInitialCandidatesJobsLoading: boolean;
        isAssignedJobListLoading: boolean;
        isTrackableSourcesLoading: boolean;
        isPublicTrackableSourcesLoading: boolean;
        isJobStepsLoading: boolean;
        isJobsListLoading: boolean;
        isConfirmJobCloseOrCancelModalOpen: boolean;
        isJobRequirementsRecommendationsLoading: boolean;
        isProceedWithRecommendedModalOpen: boolean;
        isPublishedJobsOptionsLoading: boolean;
        isJobOverviewAndResponsibilitiesLoading: boolean;
        isActiveJobCandidatesLoading: boolean;
        isApplyTagLoading: boolean;
        isDeleteTagLoading: boolean;
    };
}

const initialState: IJobSlice = {
    activeJob: null,
    activeJobCandidates: [],
    activeCandidateJobId: null,
    candidateSavedJobs: localStorage.getItem('bookmarkedJobs')
        ? JSON.parse(localStorage.getItem('bookmarkedJobs') || '')
        : [],
    jobAttributeList: [],
    jobRequirementsOptions: [],
    jobBenefitsOptions: [],
    jobsPageStatistics: null,
    jobStepperInfo: jobStepperInfoInitState,
    candidatesJobs: [],
    jobsBoardFilters: jobsBoardFiltersInitState,
    publishedJobs: [],
    assignedJobList: [],
    jobRequirementsRecomendations: [],
    formattedJobRequirementsRecomendations: [],
    jobOverviewAndResponsibilitiesRecommmendation: {
        overview: null,
        responsibilities: null,
    },
    trackableSources: {},
    publicTrackableSources: {},
    jobsList: [],
    cancelOrCloseJob: null,
    activeJobRequirementRecommendations: [],
    isRecommendationsExhausted: false,
    copiedJobSteps: null,
    uiState: {
        isJobLoading: false,
        isUpdateJobLoading: false,
        isJobsPageStatisticsLoading: false,
        isCandidatesJobsLoading: false,
        isInitialCandidatesJobsLoading: true,
        isAssignedJobListLoading: false,
        isTrackableSourcesLoading: false,
        isPublicTrackableSourcesLoading: false,
        isJobStepsLoading: false,
        isJobsListLoading: false,
        isConfirmJobCloseOrCancelModalOpen: false,
        isJobRequirementsRecommendationsLoading: false,
        isProceedWithRecommendedModalOpen: false,
        isPublishedJobsOptionsLoading: false,
        isJobOverviewAndResponsibilitiesLoading: false,
        isActiveJobCandidatesLoading: false,
        isApplyTagLoading: false,
        isDeleteTagLoading: false,
    },
};

export const sliceName = 'jobs';
export const jobsSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        fetchActiveJob: (
            state,
            _action: PayloadAction<IFetchActiveJobAction>
        ) => {
            state.uiState.isJobLoading = true;
        },
        fetchActiveJobFailed: (state) => {
            state.uiState.isJobLoading = false;
        },
        fetchJobsPageStatistics: (state) => {
            state.uiState.isJobsPageStatisticsLoading = true;
        },
        fetchJobsPageStatisticsFailed: (state) => {
            state.uiState.isJobsPageStatisticsLoading = false;
        },
        setActiveJob: (state, action: PayloadAction<ISetActiveJobAction>) => {
            state.activeJob = action.payload.job;
            state.activeJobRequirementRecommendations =
                action.payload.job?.requirementRecommendations || [];
            state.isRecommendationsExhausted =
                action.payload.job?.exhaustedRecommendations ?? false;
            state.uiState.isJobRequirementsRecommendationsLoading = false;
            state.uiState.isJobLoading = false;
        },
        setJobsPageStatistics: (
            state,
            action: PayloadAction<ISetJobsPageStatisticsAction>
        ) => {
            state.jobsPageStatistics = action.payload.statistics;
            state.uiState.isJobsPageStatisticsLoading = false;
        },
        updateActiveJob: (
            state,
            _action: PayloadAction<IUpdateActiveJobAction>
        ) => {
            state.uiState.isUpdateJobLoading = true;
        },
        updateJobStatus: (
            state,
            _action: PayloadAction<IUpdateJobStatusAction>
        ) => {
            state.uiState.isUpdateJobLoading = true;
        },
        deleteJob: (state, _action: PayloadAction<IDeleteJobAction>) => {
            state.uiState.isUpdateJobLoading = true;
        },
        fetchCandidatesJobs: (
            state,
            _action: PayloadAction<IFetchCandidatesJobsAction>
        ) => {
            if (!state.uiState.isInitialCandidatesJobsLoading) {
                state.uiState.isCandidatesJobsLoading = true;
            }
        },
        fetchCandidatesJobsFailed: (state) => {
            state.uiState.isCandidatesJobsLoading = false;
        },
        setCandidatesJobs: (
            state,
            action: PayloadAction<ISetCandidatesJobsAction>
        ) => {
            state.candidatesJobs = action.payload.jobs;
            if (state.uiState.isInitialCandidatesJobsLoading) {
                state.uiState.isInitialCandidatesJobsLoading = false;
            } else {
                state.uiState.isCandidatesJobsLoading = false;
            }
        },
        setJobsBoardFilters: (
            state,
            action: PayloadAction<ISetJobsBoardFiltersAction>
        ) => {
            state.jobsBoardFilters = action.payload.filters;
        },
        updateCandidateSavedJobs: (
            state,
            action: PayloadAction<IUpdateCandidateSavedJobsAction>
        ) => {
            state.candidateSavedJobs = action.payload.jobIds;
            localStorage.setItem(
                'bookmarkedJobs',
                JSON.stringify(state.candidateSavedJobs)
            );
        },
        setUpdateActiveJob: (
            state,
            action: PayloadAction<ISetActiveJobAction>
        ) => {
            state.activeJob = action.payload.job;
            state.uiState.isUpdateJobLoading = true;
        },
        setUpdateJobFailed: (state) => {
            state.uiState.isUpdateJobLoading = false;
        },
        fetchJobAttributeList: () => {},
        setJobAttributeList: (
            state,
            action: PayloadAction<ISetJobAttributeListAction>
        ) => {
            state.jobAttributeList = action.payload.jobAttributeList;
        },
        createJob: (state, _action: PayloadAction<ISaveJobAction>) => {
            state.uiState.isUpdateJobLoading = true;
        },
        setStepperInfo: (
            state,
            action: PayloadAction<ISetStepperInfoAction>
        ) => {
            state.jobStepperInfo = action.payload.stepperInfo;
        },
        fetchJobRequirementsOptions: (
            _state,
            _action: PayloadAction<IFetchRequirementsOptionsAction>
        ) => {},
        setJobRequirementsOptions: (
            state,
            action: PayloadAction<ISetJobRequirementsOptionsAction>
        ) => {
            state.jobRequirementsOptions = action.payload.options;
        },
        fetchJobBenefitsOptions: () => {},
        setJobBenefitsOptions: (
            state,
            action: PayloadAction<ISetJobBenefitsOptionsAction>
        ) => {
            state.jobBenefitsOptions = action.payload.options;
        },
        fetchAssignedJobList: (state) => {
            state.uiState.isAssignedJobListLoading = true;
        },
        setAssignedJobList: (
            state,
            action: PayloadAction<ISetAssignedJobListAction>
        ) => {
            state.assignedJobList = action.payload.assignedJobList;
        },
        setAssignedJobListDone: (state) => {
            state.uiState.isAssignedJobListLoading = false;
        },
        fetchTrackableSources: (state, _action: PayloadAction) => {
            state.uiState.isTrackableSourcesLoading = true;
        },
        setTrackableSources: (
            state,
            action: PayloadAction<ISetTrackableSourcesAction>
        ) => {
            state.trackableSources = action.payload.trackableSources;
        },
        fetchTrackableSourcesDone: (state) => {
            state.uiState.isTrackableSourcesLoading = false;
        },
        createTrackableSource: (
            state,
            _action: PayloadAction<ICreateTrackableSourceAction>
        ) => {
            state.uiState.isTrackableSourcesLoading = true;
        },
        setCreateTrackableSourceDone: (state) => {
            state.uiState.isTrackableSourcesLoading = false;
        },
        fetchPublicTrackableSources: (state, _action: PayloadAction) => {
            state.uiState.isPublicTrackableSourcesLoading = true;
        },
        fetchPublicTrackableSourcesDone: (state) => {
            state.uiState.isPublicTrackableSourcesLoading = false;
        },
        setPublicTrackableSources: (
            state,
            action: PayloadAction<ISetTrackableSourcesAction>
        ) => {
            state.publicTrackableSources = action.payload.trackableSources;
        },
        fetchJobSteps: (
            state,
            _action: PayloadAction<IFetchActiveJobAction>
        ) => {
            state.uiState.isJobStepsLoading = true;
        },
        setCopiedJobSteps: (
            state,
            action: PayloadAction<ISetCopiedJobStepsAction>
        ) => {
            state.copiedJobSteps = action.payload.steps;
        },
        setJobStepsDone: (state) => {
            state.uiState.isJobStepsLoading = false;
        },
        fetchJobsList: (state) => {
            state.uiState.isJobsListLoading = true;
        },
        setJobsList: (state, action: PayloadAction<ISetJobsListAction>) => {
            state.jobsList = action.payload.jobs;
        },
        setJobsListDone: (state) => {
            state.uiState.isJobsListLoading = false;
        },
        setConfirmJobCloseOrCancelModalOpen: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.uiState.isConfirmJobCloseOrCancelModalOpen = action.payload;
        },
        setCancelOrCloseJob: (
            state,
            action: PayloadAction<ISetCancelOrCloseJobAction>
        ) => {
            state.cancelOrCloseJob = action.payload;
        },
        fetchJobRequirementsRecommendations: (
            state,
            _action: PayloadAction<IFetchJobRequirementsRecomendationsAction>
        ) => {
            state.uiState.isJobRequirementsRecommendationsLoading = true;
        },
        setJobRequirementsRecomendations: (
            state,
            action: PayloadAction<ISetJobRequirementsRecomendationsAction>
        ) => {
            state.jobRequirementsRecomendations = action.payload.recomendations;
        },
        setFormattedJobRequirementsRecomendations: (
            state,
            action: PayloadAction<ISetFormattedJobRequirementsRecomendationsAction>
        ) => {
            state.formattedJobRequirementsRecomendations =
                action.payload.recomendations;
        },
        setJobRequirementsRecomendationsDone: (state) => {
            state.uiState.isJobRequirementsRecommendationsLoading = false;
        },
        addJobRequirementRecommendationToJob: (
            _state,
            _action: PayloadAction
        ) => {},
        setProceedWithRecommendedModalOpen: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.uiState.isProceedWithRecommendedModalOpen = action.payload;
        },
        fetchPublishedJobsOptions: (state) => {
            state.uiState.isPublishedJobsOptionsLoading = true;
        },
        setPublishedJobs: (
            state,
            action: PayloadAction<Array<IPublishedJob>>
        ) => {
            state.publishedJobs = action.payload;
        },
        setPublishedJobsOptionsDone: (state) => {
            state.uiState.isPublishedJobsOptionsLoading = false;
        },
        fetchJobOverviewAndResponsibilities: (
            state,
            _action: PayloadAction<IFetchJobOverviewAndResponsibilitiesAction>
        ) => {
            state.uiState.isJobOverviewAndResponsibilitiesLoading = true;
        },
        setJobOverviewAndResponsibilities: (
            state,
            action: PayloadAction<ISetJobOverviewAndResponsibilitiesAction>
        ) => {
            state.jobOverviewAndResponsibilitiesRecommmendation =
                action.payload.overviewAndResponsibilities;
        },
        setJobOverviewAndResponsibilitiesDone: (state) => {
            state.uiState.isJobOverviewAndResponsibilitiesLoading = false;
        },
        fetchActiveJobCandidates: (
            state,
            _action: PayloadAction<IFetchActiveJobCandidatesAction>
        ) => {
            state.uiState.isActiveJobCandidatesLoading = true;
        },
        setActiveJobCandidates: (
            state,
            action: PayloadAction<ISetActiveJobCandidatesAction>
        ) => {
            state.activeJobCandidates = action.payload.candidates;
        },
        setActiveJobCandidatesDone: (state) => {
            state.uiState.isActiveJobCandidatesLoading = false;
        },
        setActiveCandidateJobId: (
            state,
            action: PayloadAction<ISetActiveCandidateJobIdAction>
        ) => {
            state.activeCandidateJobId = action.payload.jobId;
        },
        updateActiveJobCandidate: (
            _state,
            _action: PayloadAction<IUpdateActiveJobCandidateAction>
        ) => {
            // This will be handled in saga
        },
        updateActiveJobCandidateName: (
            state,
            action: PayloadAction<IUpdateActiveJobCandidateNameAction>
        ) => {
            const { candidateId, firstName, lastName } = action.payload;
            const candidateName = `${firstName} ${lastName}`;
            
            console.log('[updateActiveJobCandidateName] Updating candidate:', {
                candidateId,
                candidateName,
                stepsCount: state.activeJobCandidates.length,
            });

            state.activeJobCandidates.forEach((step) => {
                step.candidates.forEach((candidate) => {
                    if (Number(candidate.candidateId) === Number(candidateId)) {
                        console.log('[updateActiveJobCandidateName] Found and updating candidate in step:', step.stepName);
                        candidate.candidateName = candidateName;
                    }
                });
            });
        },
        handleJobRequirementsRecommendationsReady: (
            state,
            action: PayloadAction<{
                recommendations: Array<IServerJobRequirementRecommendation>;
                is_exhausted: boolean;
            }>
        ) => {
            state.activeJobRequirementRecommendations =
                action.payload.recommendations;
            state.isRecommendationsExhausted = action.payload.is_exhausted;
            state.uiState.isJobRequirementsRecommendationsLoading = false;
        },
        applyTagToJob: (state, _action: PayloadAction<ISetTagAction>) => {
            state.uiState.isApplyTagLoading = true;
        },
        applyTagToJobDone: (state) => {
            state.uiState.isApplyTagLoading = false;
        },
        deleteTagFromJob: (
            state,
            _action: PayloadAction<IDeleteJobTagAction>
        ) => {
            state.uiState.isDeleteTagLoading = true;
        },
        deleteTagFromJobDone: (state) => {
            state.uiState.isDeleteTagLoading = false;
        },
    },
});

export const jobsActions = jobsSlice.actions;
export default jobsSlice.reducer;
